<template>
  <div>
    <base-card>
      <member-form></member-form>
    </base-card>
  </div>
</template>

<script>
import MemberForm from './MemberForm';
export default {
        components: {
            MemberForm: MemberForm
        }
    }
</script>

<style scoped>
</style>